<template>
    <div class="contact-us-content">

        <el-affix :z-index="maxZIndex">
            <NavBar></NavBar>
        </el-affix>

        <div class="main">
            <Breadcrumb :bread-list="breadList"></Breadcrumb>

            <div class="article-content">
                <div class="title">
                    <!-- {{ $t('aboutUs.articleTitle') }} -->
                    {{ $t('contactUs.title') }}
                </div>

                <template v-for="(item,index) in ($tm('contactUs.contentList') as any)" :key="index">
                    <div class="h2-title">
                        <span class="before">
                            {{ item.h2Title.before }}
                        </span>
                        <span class="after">
                            {{ item.h2Title.after }}
                        </span>
                    </div>

                    <div class="contact-detail">
                        <p v-for="(p,pIndex) in item.contactDetail" :key="pIndex">
                            {{ p }}
                        </p>
                    </div>
                </template>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script lang="ts" setup>
import Breadcrumb from '@/components/Breadcrumb.vue';
import { BreadType } from '@/typeDefine/EntityType'; 4
import NavBar from '@/components/NavBar.vue';
import { UtilMethods } from '@/util/UtilMethods';
import Footer from '@/components/Footer.vue';

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        text: 'index.navBar.contactUs'
    }
]

</script>

<style lang="css" scoped>
.contact-us-content .main {
    width: 90%;
    margin: 0 auto;

}

.contact-us-content .main .article-content .title {
    font-size: 30px;
    color: var(--primary-color);
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
}

.contact-us-content .article-content .h2-title .before{
    font-size: 20px;
    font-weight: bold;
    color: var(--primary-color);
    margin-right: 10px;
}

.contact-us-content .article-content .h2-title .after {
    font-size: 20px;
    font-weight: bold;
}
</style>